import trackConstants from "../constants/trackConstants";

export const retrieveTracks = (payload: any) => ({
  type: trackConstants.GET_TRACKS_LIST,
  payload,
});

export const retrieveAllTracks = (payload: any) => ({
  type: trackConstants.GET_ALL_TRACKS_REQUEST,
  payload,
});

export const retrieveTracksIncomeSummary = (payload: any) => ({
  type: trackConstants.GET_TRACKS_INCOME_SUMMARY_REQUEST,
  payload,
});

export const createTrack = (payload: any) => ({
  type: trackConstants.CREATE_TRACK_REQUEST,
  payload,
});

export const editTrack = (payload: any) => ({
  type: trackConstants.EDIT_TRACK_REQUEST,
  payload,
});

export const deleteTrack = (payload: any) => ({
  type: trackConstants.DELETE_TRACK_REQUEST,
  payload,
});

export const downloadTracksInCSV = (payload: any) => ({
  type: trackConstants.DOWNLOAD_TRACKS_IN_CSV_REQUEST,
  payload,
});

export const resetTracks = () => ({
  type: trackConstants.RESET_TRACKS,
});

export const resetDownloadTracksInCSV = () => ({
  type: trackConstants.RESET_DOWNLOAD_TRACKS_IN_CSV,
});
